import { useWatch } from 'react-hook-form';
import { Box } from '@mui/system';
import { TextField } from '@mui/material';
import { FormField } from 'components/common/Form/Fields/FormField/FormField';
import { rootTranslation } from 'utils/format';
import { SceneField } from '../fields/SceneField';
import { TrackTypeSelect } from '../fields/TrackTypeSelect';
import { LibraryField } from '../fields/LibraryField';
import { ArtistField } from '../fields/ArtistField';

const t = rootTranslation('drawers.productionSetup.tracks.filter');

export function CreateFormPanel({ useCueContainerPickerTreeView }: { useCueContainerPickerTreeView: boolean }) {
  const type = useWatch({ name: 'type' });
  const partner = useWatch({ name: 'partner' });
  const formFieldDisabled = type === 'library' && !partner;

  return (
    <Box
      sx={{
        backgroundColor: 'primary.300',
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 2,
        p: 2,
        borderRadius: '4px',
      }}
    >
      <SceneField useCueContainerPickerTreeView={useCueContainerPickerTreeView} />
      <TrackTypeSelect />
      {type === 'library' && <LibraryField />}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <FormField
          required
          label={t('title')}
          name="title"
          render={({ field, muiprops }) => (
            <TextField
              disabled={formFieldDisabled}
              {...field}
              {...muiprops}
              placeholder={t('trackTitlePlaceholder')}
              sx={{
              '& .Mui-disabled': {
                backgroundColor: 'primary.400',
                color: 'red',
                '-webkit-text-fill-color': '#312733A6',
                '&::placeholder': {
                  color: '#312733A6',
                  opacity: 1,
                },
              },
            }}
            />
        )}
        />
        {type === 'library' && <FormField
          label="Track ID"
          name="libraryTrackId"
          render={({ field, muiprops }) => (
            <TextField
              disabled={formFieldDisabled}
              {...field}
              {...muiprops}
              placeholder={t('libraryTrackIdPlaceholder')}
              sx={{
              '& .Mui-disabled': {
                backgroundColor: 'primary.400',
                color: 'red',
                '-webkit-text-fill-color': '#312733A6',
                '&::placeholder': {
                  color: '#312733A6',
                  opacity: 1,
                },
              },
            }}
            />
        )}
        />}
      </Box>
      {type === 'song' && <ArtistField />}
    </Box>
  );
}
